import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { initialStateSlice } from "../initialStateSlice";
import apis, { fetcher } from "../../apis";

const authSlice = createSlice({
  name: "auth",
  initialState: initialStateSlice,
  reducers: {
    setAuth: (state, action) => {
      state = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.body = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
        console.error(action.error);
      });
  },
});

export const { setAuth } = authSlice.actions;
export default authSlice;

export const login = createAsyncThunk("auth/login", async (payload) => {
  const email = payload.email;
  const password = payload.password;
  const result = await fetcher({
    route: "/auth/signin",
    method: "POST",
    body: { email, password },
  });
  if (result.ok) {
    const token = result.json.data.token;
    localStorage.setItem("token", token);
    return result.json.data;
  } else {
    localStorage.clear();
    throw result.json.message;
  }
});
